export const CRM_INTEGRATION_MAX_PHOTOS_PER_MESSAGE = 10

/** Число колонок сетки для 1–10 фото в пузыре чата. */
export const getPhotoGridColumnCount = (photoCount: number): number => {
  const count = Math.min(
    Math.max(photoCount, 1),
    CRM_INTEGRATION_MAX_PHOTOS_PER_MESSAGE,
  )

  if (count === 1) return 1
  if (count === 2) return 2
  if (count === 3) return 3
  if (count === 4) return 2
  if (count <= 6) return 3
  if (count <= 9) return 3
  return 3
}
